<template>
  <div class="search-item tw:px-6 tw:py-3 tw:cursor-pointer hover:tw:bg-white/5" @click="open">
    <TextPlay class="path tw:whitespace-nowrap tw:overflow-hidden tw:text-ellipsis" size="xxs" color="var(--subtitle-color)">{{ item?.path }}</TextPlay>
    <TextPlay class="title tw:overflow-hidden tw:text-ellipsis tw:line-clamp-2" color="var(--title-color)">{{ item?.title }}</TextPlay>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { toast } from '@/events'
import { useAuthStore } from '@/store/auth.store'
import { useCoursesStore } from '@/store/courses.store'

const { t } = useI18n()
const router = useRouter()
const authStore = useAuthStore()
const coursesStore = useCoursesStore()

const props = defineProps<{
  item?: Record<string, unknown>
}>()

const emit = defineEmits<{
  click: []
}>()

async function open() {
  const isAllowed = props.item?.is_liberated === true || authStore.isAdmin()

  if (!isAllowed) {
    toast.events.emit('error', {
      message: t('search_modal.error.liberation'),
      title: t('search_modal.error.title'),
    })
    return
  }

  emit('click')
  const params = await coursesStore.actionOpenLesson({
    courseId: props.item?.course_id,
    moduleId: props.item?.module_id,
    lessonId: props.item?.lesson_id,
  })

  if (props.item?.lesson_id && props.item?.module_id) {
    await router.push({ name: 'watch-lesson', params })
  }
}
</script>

<style lang="scss" scoped>
.title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
